/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { BillingProductPrice } from './BillingProductPrice';
import {
    BillingProductPriceFromJSON,
    BillingProductPriceFromJSONTyped,
    BillingProductPriceToJSON,
    BillingProductPriceToJSONTyped,
} from './BillingProductPrice';

/**
 * 
 * @export
 * @interface ListBillingProductPricesResponse
 */
export interface ListBillingProductPricesResponse {
    /**
     * 
     * @type {Array<BillingProductPrice>}
     * @memberof ListBillingProductPricesResponse
     */
    data: Array<BillingProductPrice>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListBillingProductPricesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListBillingProductPricesResponse interface.
 */
export function instanceOfListBillingProductPricesResponse(value: object): value is ListBillingProductPricesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListBillingProductPricesResponseFromJSON(json: any): ListBillingProductPricesResponse {
    return ListBillingProductPricesResponseFromJSONTyped(json, false);
}

export function ListBillingProductPricesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBillingProductPricesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BillingProductPriceFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListBillingProductPricesResponseToJSON(json: any): ListBillingProductPricesResponse {
      return ListBillingProductPricesResponseToJSONTyped(json, false);
  }

  export function ListBillingProductPricesResponseToJSONTyped(value?: ListBillingProductPricesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BillingProductPriceToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

